import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { TEMPLATE_PROP_TYPES } from '../../constants/componentPropTypes';

export default class Template extends PureComponent {
    static propTypes = TEMPLATE_PROP_TYPES;

    static defaultProps = {
        useBaseline: false,
        reverseHorizontal: false,
        reverseVertical: false,
        showOnlySmallScreen: false,
        showOnlyLargeScreen: false,
        bgColor: 'white',
        hasPadding: false,
        addSpaceBetween: false,
    };

    render() {
        const {
            children,
            useBaseline,
            reverseHorizontal,
            reverseVertical,
            showOnlySmallScreen,
            showOnlyLargeScreen,
            bgColor,
            hasPadding,
            addSpaceBetween,
        } = this.props;

        const smallScreenClassName = classnames(
            'eds-show-down-sm',
            'eds-align--center-vertical',
            `eds-bg-color--${bgColor}`,
            {
                'eds-l-pad-all-4': hasPadding,
                'marketing-template--reverse-vertical': reverseVertical,
                'marketing-template--vertical': !reverseVertical,
            },
        );
        const largeScreenClassName = classnames(
            'eds-show-up-sw',
            `eds-bg-color--${bgColor}`,
            {
                'eds-l-pad-all-8': hasPadding,
                'eds-align--center': !useBaseline,
                'eds-align--space-between': addSpaceBetween,
                'marketing-template--reverse-horizontal': reverseHorizontal,
            },
        );

        const largeScreenLayout = !showOnlySmallScreen && (
            <div className={largeScreenClassName}>{children}</div>
        );

        const smallScreenLayout = !showOnlyLargeScreen && (
            <div className={smallScreenClassName}>{children}</div>
        );

        return (
            <div>
                {largeScreenLayout}
                {smallScreenLayout}
            </div>
        );
    }
}
